import React from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const StopIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 20 20"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect fill="currentColor" height="10" rx="1.5" width="10" x="5" y="5" />
  </svg>
);

StopIcon.propTypes = {
  ...sizePropsTypes,
};

export default StopIcon;
